import { FETCH_QUESTIONS, INCREMENT_QUESTION, RESET_PROGRESS, RESET_QUESTION } from '../actions'
import { USER } from '../config'
import Lockr from 'lockr'

const user = Lockr.get(USER, undefined)
const current = user ? user.progress : 0
const initialState = {
  questions: [],
  current,
  noQuestions: null
}

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_QUESTIONS:
      return {
        ...state,
        ...action.payload
      }
    case INCREMENT_QUESTION:
      return {
        ...state,
        current: state.current + 1
      }

    case RESET_QUESTION:
      return {
        ...state,
        current: action.payload
      }

    case RESET_PROGRESS:
      return {
        ...state,
        current: 0
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/trivia.js